import styled from 'styled-components';
import { Button } from '../../atoms/button';
import { Caption01 } from '../../styles';

export const Divider = styled.hr`
  margin: var(--layout-01);
  border: none;
  border-top: 1px solid var(--border-color);
`;

export const Label = styled.div`
  ${Caption01};
  padding: 0 var(--layout-01);
  margin: 0 0 var(--spacing-03);
  color: var(--gray-50);
`;

interface ButtonProps extends React.ComponentProps<typeof Button> {
  textType?: string;
}

// Migration blocker: package variants do not preserve a neutral text action
// whose hover surface alone switches to the destructive treatment.
export const Action = styled(Button).attrs({
  type: 'text',
})<ButtonProps>`
  --action-hover-background: var(--item-hover-bg);
  width: 100%;
  &:hover,
  &:focus,
  &:active {
    background: ${({ textType }) =>
      textType === 'danger'
        ? 'var(--ozone-red-surface)'
        : 'var(--action-hover-background)'};
  }
`;
